<template>
  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GameBanner :fake_counter="fakeCounter" />
    <GamePacks :extra-pack="extraPack" />
    <ELearningBanner
      v-if="
        ![
          'marvel-rivals-boost',
          'rematch-boost',
          'clash-royale-boost',
        ].includes(currentGameSlug)
      "
    />
    <GameBooster v-if="isLoaded && currentGameSlug !== 'marvel-rivals-boost'" />
    <GameBooster v-if="currentGameSlug === 'marvel-rivals-boost'" />
    <OptimalSection v-if="isLoaded" />

    <div
      class="d-flex-column justify-start"
      v-if="gameFaqs.length > 0 && isLoaded"
    >
      <div class="d-flex-column gap-0">
        <p
          class="t-orange regular-l f-w-500 font-family-1"
          style="letter-spacing: 2px"
        >
          {{ $t("homepage.faq") }}
        </p>
        <h2
          class="t-white font-family-1 title-h2 f-w-600"
          style="text-align: center"
        >
          {{ $t("homepage.got_a_question") }}
          <br />
          {{ $t("homepage.we_have")
          }}<span class="t-light-orange">{{ $t("homepage.answers") }}</span
          >!
        </h2>
      </div>

      <div class="d-flex-row align-start lg-row-to-col">
        <div class="d-flex-column gap-0">
          <Faq :faqs="[...gameFaqs].splice(0, 4)" variant="pack twocol" />
        </div>
        <div class="d-flex-column gap-0">
          <Faq :faqs="[...gameFaqs].splice(4, 6)" variant="pack twocol" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import GameBanner from "../banners/GameBanner.vue";
import GamePacks from "../sections/overview/GamePacks.vue";
import ELearningBanner from "../banners/ELearningBanner.vue";
import GameBooster from "../sections/overview/GameBooster.vue";
import OptimalSection from "../common/OptimalSection.vue";
import Faq from "../custom/Faq.vue";
const { extraPack, currentGameSlug } = useGameComposable();
const gameStore = useGameStore();
import { ref } from "vue";
const isLoaded = ref(false);

const fakeCounter = computed(() => {
  if (
    currentGameSlug === "marvel-rivals-boost" ||
    currentGameSlug === "rematch-boost" ||
    currentGameSlug === "clash-royale-boost"
  ) {
    return true;
  }
  return false;
});
const gameFaqs = computed(() => {
  if (gameStore.getGame?.faqs) {
    return gameStore.getGame?.faqs;
  }
  return [];
});
function pageLoading() {
  isLoaded.value = true;
  window.removeEventListener("scroll", pageLoading);
}

onNuxtReady(() => {
  window.addEventListener("scroll", pageLoading);
});
</script>
